import React from "react";
import { Route, Redirect, Switch } from "react-router";
import SignInCallback from "./SignInCallback";
import SignoutCallback from "./SignOutCallback";
import { appPaths } from "../../Common";

export default () => (
  <Switch>
    <Route path={appPaths.auth.signInCallback} component={SignInCallback} />
    <Route path={appPaths.auth.signOutCallback} component={SignoutCallback} />
  </Switch>
);
